import { Box, Button } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import strings from "../../constants/StringConstants";
import customButtonStyles from "./CustomButton.styles";

interface CustomProps {
  label?: string | JSX.Element;
  onClick: Function;
  loading?: boolean;
  customClasses?: any;
  icon?: JSX.Element;
  startIcon?: JSX.Element; // <-- add this line
  disabled?: boolean;
  type?: string;
}

const CustomButton = (props: CustomProps) => {
  const classes = customButtonStyles;

  const btnStyle =
    props.type === strings.PRIMARY
      ? classes.primaryBtnStyle
      : classes.secondaryBtnStyle;

  const processing = props.loading ? props.loading : false;
  const disabled = props.disabled ? props.disabled : false;

  return (
    <Button
      sx={props.customClasses ? [btnStyle, props.customClasses] : btnStyle}
      onClick={(event: any) => props.onClick(event)}
      disabled={processing || disabled}
      startIcon={props.startIcon}
    >
      <Box sx={classes.btnBox}>
        {processing ? (
          <CircularProgress sx={classes.loadingStyle} />
        ) : (
          <>
            {props.icon}
            {props.label}
          </>
        )}
      </Box>
    </Button>
  );
};

export default CustomButton;
